module.exports = __webpack_public_path__ + "static/media/Completed.e83c3873.svg";